// providerFields/KaleyraFields.tsx
import React from "react";
import { Input, Tooltip } from "antd";

interface KaleyraFieldsProps {
  credentials: any;
  onChange: (key: string, value: string) => void;
}

const KaleyraFields: React.FC<KaleyraFieldsProps> = ({
  credentials,
  onChange,
}) => {
  return (
    <div className="d-grid" style={{ gap: 10 }}>
      <div>
        <div className="d-flex align-items-center justify-content-between mb-1">
          <label className="form-label fw-semibold mb-0">
            API Key <span className="text-danger">*</span>
          </label>
          <Tooltip title="API key created in Kaleyra dashboard for WhatsApp.">
            <i className="ti ti-info-circle text-muted" />
          </Tooltip>
        </div>
        <Input
          placeholder="API Key *"
          value={credentials.api_key || ""}
          onChange={(e) => onChange("api_key", e.target.value)}
        />
      </div>

      <div>
        <div className="d-flex align-items-center justify-content-between mb-1">
          <label className="form-label fw-semibold mb-0">
            SID <span className="text-danger">*</span>
          </label>
          <Tooltip title="Kaleyra SID for your WhatsApp account / project.">
            <i className="ti ti-info-circle text-muted" />
          </Tooltip>
        </div>
        <Input
          placeholder="SID *"
          value={credentials.sid || ""}
          onChange={(e) => onChange("sid", e.target.value)}
        />
      </div>

      <div>
        <div className="d-flex align-items-center justify-content-between mb-1">
          <label className="form-label fw-semibold mb-0">
            API Domain <span className="text-danger">*</span>
          </label>
          <Tooltip title="Region specific domain, e.g. api-in.kaleyra.io for India.">
            <i className="ti ti-info-circle text-muted" />
          </Tooltip>
        </div>
        <Input
          placeholder="API Domain *"
          value={credentials.api_domain || ""}
          onChange={(e) => onChange("api_domain", e.target.value)}
        />
      </div>
    </div>
  );
};

export default KaleyraFields;
